export default __webpack_public_path__ + "static/media/banner-12.24bdd160.jpg";